import { TestUser } from '../components/TestNumbers/types.ts';
import Api from './Api.ts';

export const getAllTestNumbers = async () => {
  const response = await Api.get('/test-numbers');
  return response.data;
};

export const createTestNumber = async (data: TestUser) => {
  const response = await Api.post('/test-numbers', data);
  console.log('response', response.data.data);
  return response.data;
};

export const deleteTestNumber = async (id: string) => {
  const response = await Api.delete(`/test-numbers/${id}`);
  return response.data;
};

export const getStats = async () => {
  const response = await Api.get('/dashboard/stats');
  return response.data;
};
